<div class="upload">
    <app-upload></app-upload>
</div>

<div class="download">
    <app-download></app-download>
</div>